import { useNavigate } from 'react-router-dom';
import { listBotsFromProjectsConfig } from '../../config/getBotConfig';
import classes from './AdminBotPicker.module.css';

export default function AdminBotPicker() {
  const navigate = useNavigate();
  const bots = listBotsFromProjectsConfig();

  return (
    <div className={classes.wrap}>
      <h1 className={classes.title}>בחירת בוט לעריכת עיצוב</h1>
      <p className={classes.sub}>
        בחרו פרויקט ובוט כדי לפתוח את מסך העריכה עם תצוגה חיה.
      </p>
      {bots.length === 0 ? (
        <p className={classes.empty}>לא הוגדרו בוטים </p>
      ) : (
        <ul className={classes.list}>
          {bots.map(({ projectKey, botName }) => (
            <li key={`${projectKey}/${botName}`} className={classes.row}>
              <div className={classes.meta}>
                <span className={classes.project}>{projectKey}</span>
                <span className={classes.botName}>{botName}</span>
              </div>
              <button
                type="button"
                className={classes.openBtn}
                onClick={() => navigate(`/admin/${projectKey}/${botName}`)}
              >
                עריכה
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}